var React = require('react');

function ArrowBlack (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44786","data-name":"Group 44786","transform":"translate(437 65) rotate(180)"},[React.createElement("rect",{"id":"Rectangle_37726","data-name":"Rectangle 37726","width":"22","height":"22","transform":"translate(415 43)","fill":"none","key":0}),React.createElement("path",{"id":"arrow-left-r","d":"M11.061,5l-6.25,6.25H21.75v1.5H4.811L11.061,19,10,20.061,1.939,12,10,3.939Z","transform":"translate(414.059 42.061)","key":1})]));
}

ArrowBlack.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = ArrowBlack;

ArrowBlack.default = ArrowBlack;
